/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Start_ButtonInputs */



/**
* | output |
* | --- |
* | "Start OCR" |
*
* @param {Ocr_Start_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_start_button = /** @type {((inputs?: Ocr_Start_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Start_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrer l'OCR")
	if (locale === "de") return /** @type {LocalizedString} */ ("OCR starten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvia OCR")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запуск OCR")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciar OCR")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始 OCR")
	if (locale === "ja") return /** @type {LocalizedString} */ ("OCRを開始する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओसीआर शुरू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciar OCR")
	return /** @type {LocalizedString} */ ("Start OCR")
});